'use client';

import { c as _c } from "react/compiler-runtime";
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';
import { IS_SSR } from '../constants';
import { getQueryClient } from './queryClient';
const ReactQueryDevtools = process.env.NODE_ENV === 'development' ? dynamic(() => import('@tanstack/react-query-devtools').then(mod => mod.ReactQueryDevtools), {
  ssr: false
}) : () => null;
const persister = createSyncStoragePersister({
  storage: IS_SSR ? undefined : window.localStorage
});
export type QueryProviderProps = PropsWithChildren;
export function QueryProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    t2 = {
      persister,
      maxAge: 86400000,
      buster: ""
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <PersistQueryClientProvider client={t1} persistOptions={t2}>{children}{t3}</PersistQueryClientProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}